
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16c0 6.877 4.339 12.739 10.428 15.002L10 32h12l-.428-.998C27.661 28.739 32 22.877 32 16zm-16.788 3.838a2 2 0 111.576.001L16 18l-.788 1.838zm1.609.077a4 4 0 10-1.641-.002l-2.332 5.441A8.002 8.002 0 018 17.999c0-4.418 3.582-8.375 8-8.375s8 3.957 8 8.375a8.003 8.003 0 01-4.848 7.355l-2.331-5.439zm4.693 10.951l-2.31-5.39C23.155 24.14 26 20.403 26 16c0-5.523-4.477-10-10-10S6 10.477 6 16c0 4.402 2.845 8.14 6.796 9.476l-2.31 5.39C5.499 28.726 2.005 23.771 2.005 18 2.005 10.271 8.271 3.63 16 3.63S29.995 10.271 29.995 18c0 5.771-3.494 10.726-8.481 12.866z"}})])
          )
        }
      }
    